import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import './inicio.css';

const Inicio = () => {

    const [t, i18n] = useTranslation("sobre_mi");
    const [g] = useTranslation("global");
    const [isMobile, setIsMobile] = useState(false);

    const isEnglish = i18n.language === 'en';

    const getLinkUrl = () => {
        if (isEnglish) {
            return isMobile
                ? 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-movil-EN.pdf'
                : 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-desktop-EN.pdf';
        } else {
            return isMobile
                ? 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-movil-ES.pdf'
                : 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-desktop-ES.pdf';
        }
    };


    return (
        <div className="_ngcontent-ng-c3910305518">
            <div className='_nghost-ng-c2043221220'>
                <section aria-label="Banner de Ricardo Salinas" class="about-banner">
                    <div class="about-banner__copy">
                        <p class="about-banner__quote">{t("2026.hero")}</p>
                        <p class="about-banner__author">— Ricardo Salinas</p>

                        {/* <div  class="about-banner__logo-wrap"><img 
                            loading="lazy" class="about-banner__logo" src="/assets/img2026/logo_grupo_salinas_color.png"
                            alt="Grupo Salinas" />
                            <p  class="about-banner__role">{t("2026.herosub")}
                            </p>
                        </div>*/}
                    </div>
                    <div aria-hidden="true" class="about-banner__media"><img
                        loading="eager" fetchpriority="high"
                        src="/assets/img2026/prueba_img.png" alt="Ricardo Salinas" /></div>
                </section>
            </div>
            <div className="_nghost-ng-c4086891296">
                <section class="about-section about-section--text-left about-section-initial">
                    <div class="about-section__media about-section__media_desk">
                        <div class="about-section__embed"><iframe
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""
                            src="https://www.youtube.com/embed/hkxBR19TJH8?si=YHn2tOOAVAtX_aIB" title="Video introductorio sobre Ricardo Salinas">

                        </iframe>

                        </div>
                    </div>
                    <div class="about-section__content">
                        <h1 class="about-section__title">{t("2026.about")}</h1>
                        <p class="about-section__paragraph"> {t("2026.about2")} </p>
                        <div class="about-section__media about-section__media_mov">
                            <div class="about-section__embed"><iframe
                                loading="lazy"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""
                                src="https://www.youtube.com/embed/hkxBR19TJH8?si=YHn2tOOAVAtX_aIB" title="Video introductorio sobre Ricardo Salinas">

                            </iframe>

                            </div>
                        </div>
                        <div className='div-bout-button'>
                            <a target="_blank" rel="noreferrer" class="about-button"
                                href={getLinkUrl()}> {t("2026.aboutbtn")} </a>
                        </div>
                    </div>
                </section>
                <section class="about-section">
                    <div class="about-section__media"><img
                        loading="lazy" src="/assets/img2026/about_me_1.png"
                        alt="Ricardo Salinas en un foro de fundaciones" /></div>
                    <div class="about-section__content">
                        <h2 class="about-section__title">{t("2026.fundacion")} </h2>
                        <p class="about-section__paragraph" dangerouslySetInnerHTML={{ __html: t("2026.fundacion2") }}></p>
                        <div class="about-logos about-logos--double">
                            <a href='https://www.centroricardobsalinaspliego.org/' target='_blank'><img
                                loading="lazy" src="/assets/img2026/logo-centro2.png"
                                alt="Centro Ricardo Salinas Pliego" /></a>
                            <a href='https://www.fundacionazteca.org/' target='_blank'><img loading="lazy"
                                src="/assets/img2026/logo_faz_negro.png" alt="Fundación Azteca de Grupo Salinas" /></a>

                        </div>

                    </div>
                </section>
                <section class="about-section about-section--text-left">
                    <div class="about-section__media"><img
                        loading="lazy" src="/assets/img2026/Ricardo_B_Salinas-expo.png"
                        alt="Ricardo Salinas dando una conferencia" />
                        <a target="_blank"
                            rel="noreferrer" class="about-button only-desk"
                            href="https://www.ricardosalinas.com/images/tesis/Tesis-Doctorado.pdf"> {t("2026.tesis")} </a>
                    </div>
                    <div class="about-section__content">
                        <h2 class="about-section__title">{t("2026.exponente")} </h2>
                        <p class="about-section__paragraph" dangerouslySetInnerHTML={{ __html: t("2026.foros") }}></p>
                        <p class="about-section__paragraph"> {t("2026.foros2")} </p>
                        <a target="_blank"
                            rel="noreferrer" class="about-button about-button--full2 only-mov"
                            href="https://www.ricardosalinas.com/images/tesis/Tesis-Doctorado.pdf"> {t("2026.tesis")} </a>
                    </div>
                </section>
                <section class="about-section">
                    <div class="about-section__media"><img
                        loading="lazy" src="/assets/img2026/about_me_3.png"
                        alt="Ricardo Salinas con estudiantes" /></div>
                    <div class="about-section__content">
                        <h2 class="about-section__title">{t("2026.universidad")}</h2>
                        <p class="about-section__paragraph"> {t("2026.universidad2")} </p>
                        <div class="about-logos">
                            <a href='https://www.ulibertad.edu.mx/es' target='_blank'><img loading="lazy"
                                src="/assets/img2026/logo_universidad_de_la_libertad.png"
                                alt="Logo Universidad de la Libertad" /></a></div>
                    </div>
                </section>
                <section class="about-section about-section--text-left about-section-end">
                    <div class="about-section__media"><img
                        loading="lazy" src="/assets/img2026/682640955a9d1.png"
                        alt="Ricardo Salinas compartiendo reflexiones" /></div>
                    <div class="about-section__content">
                        <h2 class="about-section__title">{t("2026.reflexion")}</h2>
                        <p class="about-section__paragraph"> {t("2026.reflexion2")} </p>
                        <p class="about-section__paragraph"><strong
                        >{t("2026.textos")}</strong></p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Inicio;